import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EFilterType, EStrategy, IFilterOptions, IFilterParams, IFilterValue } from '../filter.type';

@Component({
  selector: 'bixi-filter-advance',
  host: {
    '[class.bixi-filter-advance]': 'true'
  },
  template: `
    <div class="container">
      <ng-container *ngFor="let option of options">
        <ng-container [ngSwitch]="option.type">
          <bixi-filter-advance-text
            *ngSwitchCase="'text'"
            [filterParams]="filterParams"
            [option]="option"
            (valueChange)="onModelChange($event, option.key)"
          ></bixi-filter-advance-text>
          <bixi-filter-advance-date-range
            *ngSwitchCase="'dateRange'"
            [filterParams]="filterParams"
            [option]="option"
            (valueChange)="onModelChange($event, option.key)"
          ></bixi-filter-advance-date-range>
          <bixi-filter-advance-select
            *ngSwitchCase="'select'"
            [filterParams]="filterParams"
            [option]="option"
            (valueChange)="onModelChange($event, option.key)"
          ></bixi-filter-advance-select>
        </ng-container>
      </ng-container>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BixiFilterAdvanceComponent {
  @Input() options: IFilterOptions;
  @Input() filterParams: IFilterParams = {};
  @Output() filterParamsChange = new EventEmitter<IFilterParams>();
  @Output() searchChange = new EventEmitter<{ mode: EStrategy; type: EFilterType; value: IFilterParams }>();

  onModelChange(data: { mode: EStrategy; type: EFilterType; value: IFilterValue }, key: string) {
    this.filterParams[key] = data.value;
    this.filterParamsChange.emit(this.filterParams);
    this.searchChange.emit({ mode: data.mode, type: data.type, value: this.filterParams });
  }
}
